import React from 'react';
import PropTypes from 'prop-types';

import SideNav from './SideNav';

const NavWrapper = ({ navItems, children, header }) => (
  <div className="nav-wrapper">
    <SideNav navItems={navItems} header={header} />
    {children && (
      <div className="main-content">
        <div className="content-wrapper">{children}</div>
      </div>
    )}
  </div>
);

NavWrapper.defaultProps = {
  header: '',
};

NavWrapper.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    path: PropTypes.string,
  })).isRequired,
  children: PropTypes.node.isRequired,
  header: PropTypes.string,
};

export default NavWrapper;



// WEBPACK FOOTER //
// ./src/components/siteNav/NavWrapper.js